import { AuthorCard } from '@components/author-card'
import { Author } from '@services/api/authors'
import Link from 'next/link'
interface Props {
  authors: Author[]
}

export const ArticleWriter: React.FC<Props> = ({ authors = [] }) => {
  return (
    <div className="flex flex-col mt-10">
      <div className="flex flex-col gap-y-4 sm:flex-row justify-between items-center">
        <span className="font-robotoSlab text-lg">
          Conheça os Articulistas do Portal Solar
        </span>
        <Link href="/noticias/articulistas" passHref>
          <span>Veja todos os articulistas</span>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 justify-between mt-5">
        {authors.map(author => (
          <AuthorCard
            key={author.id}
            author={author?.name || 'Imagem Articulista'}
            src={author?.avatar || '/no-profile-avatar.svg'}
            path={author.path}
            companyName={author.companyName}
          />
        ))}
      </div>
    </div>
  )
}
